export const ETH_EVENT_ACCOUNTS_CHANGED = 'accountsChanged'
export const ETH_EVENT_CHAIN_CHANGED = 'chainChanged'
export const ETH_CODE_PROCESSING = -32002

export const KEY_ON_CHAIN_CHANGES = 'key-chainChanged'
